import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPaymentFailedPaymentDetailsGet = {
    path: "/payment-failed/payment-details",
    method: ERouteHttpVerb.GET
};
export { routeLocationPaymentFailedPaymentDetailsGet };
